// extracted by mini-css-extract-plugin
export default {"MainContainer":"MainSection_MainContainer__OPoOu","Line":"MainSection_Line__65YTK"};